import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  box: {
    textAlign: 'center'
  },
  text: {
    color: '#071B27',
    marginTop: '20px',
    maxWidth: '240px'
  }
});

export default useStyles;
